module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki-128x128-6782d1e854f02a0fb85a8aec3040465c.png";